/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FaceASadIcon64Regular = forwardRef('FaceASadIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M20.892 43.436C22.174 39.212 26.746 36 32.007 36c5.26 0 9.832 3.212 11.114 7.436a1.5 1.5 0 0 0 2.87-.872C44.267 36.878 38.37 33 32.008 33c-6.363 0-12.26 3.878-13.986 9.564a1.5 1.5 0 1 0 2.87.872Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32 6C17.64 6 6 17.64 6 32s11.64 26 26 26 26-11.64 26-26S46.36 6 32 6ZM9 32C9 19.297 19.297 9 32 9s23 10.297 23 23-10.297 23-23 23S9 44.703 9 32Z" })));
});
